<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=list>Список договоров</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить договор</li>
        </ol>
    </nav>

    <form class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Клиент</div>
            <select @change="onChangeClient($event)" v-model="forms.client.selected" class="form-select">
                <option v-for="(item, key) in forms.client.items" v-bind:value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>

        <div class="mb-4">
            <div class="form-label">Организация</div>
            <select :disabled="!forms.client.selected" v-model="forms.organization.selected" class="form-select">
                <option v-for="(item, key) in forms.organization.items" v-bind:value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>

        <div class="mb-4">
            <div class="form-label">Название</div>
            <input
                type="text"
                class="form-control mb-3"
                v-model="forms.data.name"
                placeholder="Введите название договора">
        </div>

        <div class="mb-4">
            <div class="form-label">Номер договора</div>
            <input
                type="text"
                class="form-control mb-3"
                v-model="forms.data.number"
                placeholder="Введите номер договора">
        </div>

        <div class="mb-4">
            <label class="form-label">Дата начала действие</label>
            <input
                type="date"
                class="form-control mb-3"
                v-model="forms.data.date"
                placeholder="Введите дату начала действия договора">
        </div>


        <div class="mb-4">
            <label class="form-label">Файл</label>
            <input
                accept="application/pdf"
                ref="contractFile"
                @change="onChangeFile($event)"
                type="file"
                class="form-control mb-3">
        </div>
    </form>

    <div class="col-md-4">
        <div class="d-flex align-items-stretch py-3">
            <button @click="create" class="btn btn-md btn-primary flex-grow-1 me-3">
                Добавить
            </button>
            <a href="/documents/contracts" class="btn btn-md btn-outline-dark flex-grow-1">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContractCreateComponent",
    components: { Alert },
    props: {
        list: String
    },
    data: function () {
        return {
            forms: {
                client: {
                    selected: null,
                    items: []
                },
                organization: {
                    selected: null,
                    items: []
                },
                data: {
                    name: null,
                    date: null,
                    number: null
                },
                file: {
                    selected: null
                }
            },
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        onChangeClient: async function (e) {
            const response = await axios.get('/organizational/organizations/list', {params: {
                    page: 1,
                    limit: 100,
                    client_id: e.target.value
                }}).catch(res => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список организаций, что-то пошло не так' });
            });

            if (response.data.status == 'ok') {
                this.forms.organization.items = response.data.items;
            }

            if (response.data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
            }
        },
        getClients: async function() {
            const response = await axios.get('/organizational/client/list', {params: {
                    page: 1,
                    limit: 100
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список клиентов, что-то пошло не так' });
            });

            if (response.data.status == 'ok') {
                this.forms.client.items = response.data.items;
            }

            if (response.data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
            }
        },
        onChangeFile: function (e) {
            if (!e.target.files[0] || e.target.files[0].type !== 'application/pdf') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Только файлы с расширением pdf' });
                e.target.value = null;
            }

            if (e.target.files[0] && e.target.files[0].type === 'application/pdf') {
                this.forms.file.selected = e.target.files[0];
            }
        },
        create: async function() {
            if (!this.forms.client.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента' });
                return;
            }

            if (!this.forms.organization.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите организацию' });
                return;
            }

            if (!this.forms.data.name) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название документа' });
                return;
            }

            if (!this.forms.data.number) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите номер документа' });
                return;
            }

            if (!this.forms.data.date) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите дату документа' });
                return;
            }

            if (!this.forms.file.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Добавьте файл' });
                return;
            }

            const formData = new FormData();

            formData.append('client_id', this.forms.client.selected);
            formData.append('org_id', this.forms.organization.selected);
            formData.append('name', this.forms.data.name);
            formData.append('number', this.forms.data.number);
            formData.append('date', this.forms.data.date);
            formData.append('file', this.forms.file.selected);

            const response = await axios.post('/documents/contracts/create/contract', formData)
                .catch(res => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось добавить договор, что-то пошло не так' });
                }
            );

            if (response.data.status == 'ok') {
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Договор успешно добавлен' });
                window.location.href = '/documents/contracts';
            }

            if (response.data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
            }
        },
    },
    async mounted() {
        await this.getClients();
    }
}
</script>
